import { ApartmentOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { Button, Card, Tag, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import BrandLogo from 'assets/img/workplansiq-logo.svg';
import { DEMO_SCENARIOS } from 'services/tenant/demoScenarioService';

export default function DemoScenariosPage() {
  const navigate = useNavigate();

  return (
    <main className="demo-scenarios-page">
      <div className="demo-scenarios-shell">
        <img src={BrandLogo} alt="WorkPlansIQ" />
        <Typography.Text className="tenant-selection-eyebrow">UI FLOW DEMONSTRATION</Typography.Text>
        <Typography.Title level={2}>Choose a demo scenario</Typography.Title>
        <Typography.Paragraph type="secondary">The selected fixture is applied after authentication, then the normal membership routing resolver runs.</Typography.Paragraph>
        <div className="demo-scenarios-grid">
          {DEMO_SCENARIOS.map((scenario, index) => (
            <Card key={scenario.id} className="demo-scenario-card">
              <div className="demo-scenario-card-heading"><ApartmentOutlined /><Tag>SCENARIO {index + 1}</Tag></div>
              <Typography.Title level={4}>{scenario.title}</Typography.Title>
              <Typography.Paragraph>{scenario.description}</Typography.Paragraph>
              <Button type="primary" block onClick={() => navigate(`/?demoScenario=${encodeURIComponent(scenario.id)}`)}>Run Scenario <ArrowRightOutlined /></Button>
            </Card>
          ))}
        </div>
      </div>
    </main>
  );
}
